import { render, staticRenderFns } from "./ScreeningHistory.vue?vue&type=template&id=50e97686&scoped=true&"
import script from "./ScreeningHistory.vue?vue&type=script&lang=js&"
export * from "./ScreeningHistory.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningHistory.vue?vue&type=style&index=0&id=50e97686&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e97686",
  null
  
)

export default component.exports